<template>
    <div class="flex flex-col justify-center">
        <HeaderComponent title="Affiliates" :show-back-button="false" :actions="authUser.is_admin ? [
            { label: 'Export to CSV', click: exportToCSV, class: 'bg-blue-500 text-white mb-4 px-4 py-2 rounded my-8' },
        ] : []" />
        <template v-for="affiliate in affiliates" :key="affiliate.uuid">
            <OrganizationChart :value="affiliate" :collapsible="true" class="overflow-y-scroll">
                <template #default="slotProps">
                    <div v-if="slotProps.node.is_fake_parent || slotProps.node.id === authUserAffiliate.id"
                        class="px-8">
                        <div class="fakeParent"></div>
                    </div>
                    <div class="flex flex-col gap-4" v-else>
                        <span class="text-sm">
                            {{ slotProps.node.name }} - <span class="text-gray-500">{{ slotProps.node.affiliate_type.name }}</span>
                        </span>
                        <span class="text-xs">{{ slotProps.node.owner.full_name }}</span>
                        <ol>
                            <Link :href="'/affiliates/' + slotProps.node.short_uuid + '/reports'" v-if="authUser.is_admin">
                                <li class="text-xs text-blue-500 hover:text-blue-800">
                                    View Reports
                                </li>
                            </Link>
                            <Link :href="'/affiliates/' + slotProps.node.short_uuid + '/edit'" v-if="authUser.is_admin">
                                <li class="text-xs text-blue-500 hover:text-blue-800">
                                    Edit Affiliate
                                </li>
                            </Link>
                            <Link :href="'/affiliates/' + slotProps.node.short_uuid + '/submissions'">
                                <li class="text-xs text-blue-500 hover:text-blue-800">
                                    View Submissions ({{ slotProps.node.affiliate_submissions.length >= 1 ? slotProps.node.affiliate_submissions[0].count : 0 }})
                                </li>
                            </Link>
                            <Link :href="'/' + slotProps.node.short_uuid">
                                <li class="text-xs text-blue-500 hover:text-blue-800">
                                    View Form
                                </li>
                            </Link>
                            <Link :href="'/affiliates/' + slotProps.node.short_uuid + '/links'">
                                <li class="text-xs text-blue-500 hover:text-blue-800">
                                    View Links
                                </li>
                            </Link>
                        </ol>
                    </div>
                </template>
            </OrganizationChart>
        </template>
    </div>
</template>
<style>
.p-organizationchart-node:has(.fakeParent) {
    border: unset !important;
}
tr:has(.fakeParent) + tr .p-organizationchart-connector-down {
    background: unset;
}
.p-organizationchart-node:has(.fakeParent) .p-organizationchart-node-toggle-button {
    display: none;
}
[data-pc-section="root"] > table.p-organizationchart-table > tbody:not(:has(tr.p-organizationchart-node-children > td:nth-child(n+2))) > tr.p-organizationchart-connectors {
    display: none;
}

</style>

<script setup>
import { computed } from "vue";
import { usePage, Link } from "@inertiajs/vue3";
import OrganizationChart from "primevue/organizationchart";
import HeaderComponent from "@/Components/HeaderComponent.vue";

const page = usePage();

const affiliates = computed(() => page.props.affiliates);
const authUserAffiliate = computed(() => page.props.authUserAffiliate);
const authUser = computed(() => page.props.authUser);

const flattenAffiliates = (affiliates) => {
    let flatList = [];
    const flatten = (affiliate, parentName = "") => {
        flatList.push({
            key: affiliate.id,
            uuid: affiliate.uuid,
            short_uuid: affiliate.short_uuid,
            name: affiliate.name,
            parent: parentName,
        });
        if (affiliate.children) {
            affiliate.children.forEach((child) =>
                flatten(child, affiliate.name),
            );
        }
    };
    affiliates.forEach((affiliate) => flatten(affiliate));
    return flatList;
};

const exportToCSV = () => {
    const flatAffiliates = flattenAffiliates(affiliates.value);
    const csvContent =
        "data:text/csv;charset=utf-8," +
        "UUID,Name,Parent\n" +
        flatAffiliates
            .map(
                (affiliate) =>
                    `${affiliate.short_uuid},${affiliate.name},${affiliate.parent}`,
            )
            .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "affiliates.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
</script>
